import Banner from "../../sections/common/banner";
import SectionThanks from "../../sections/home/index/section-thanks"
import SectionAchivements1 from "../../sections/home/index2/section-achivements1"
import { data } from "../../../globals/data/about-us";

export default function Thanks() {
    return (
        <>
            <Banner _data={data.banner} />
            <SectionThanks _data={data.whatwedo} />
            <SectionAchivements1 _data={data.achivements} />
        </>
    )
}